export enum DocType {
  HARDSHIP = 'HARDSHIP',
  GRANT = 'GRANT',
}

export enum ApplicationStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  RETURNED = 'RETURNED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  EXPIRED = 'EXPIRED',
  PAYMENT_EXPIRED = 'PAYMENT_EXPIRED',
  RETURNED_EXPIRED = 'RETURNED_EXPIRED',
}

export enum ReviewStatus {
  VALIDATED = 'VALIDATED',
}

export enum GrantNames {
  FOOD = 'Food',
  CLOTHING = 'Clothing',
}

export enum PaymentStatus {
  NOT_INITIALIZED = 'Not Initialized',
  PAID = 'Paid',
  REJECTED = 'Rejected',
  REFUND = 'Refund',
  SCHEDULED = 'Scheduled',
  UNCLAIMED = 'Unclaimed',
  PENDING = 'Pending',
  COMPLETED = 'Paid',
  FAILED = 'Failed',
  EXPIRED = 'Expired',
}

export const AccordionStatus = {
  COMPLETE: { key: 'COMPLETE', value: 'Complete' },
  INPROGRESS: { key: 'INPROGRESS', value: 'In Progress' },
};
export enum ButtonVisibility {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  REVIEW = 'REVIEW',
  RETURN = 'RETURN',
  SUBMIT = 'SUBMIT',
  CANCEL = 'CANCEL',
  DRAFT = 'DRAFT',
}

export const ApplicationStatusText = {
  [ApplicationStatus.APPROVED]: 'Approved',
  [ApplicationStatus.REJECTED]: 'Declined',
  [ApplicationStatus.SUBMITTED]: 'Pending review',
  [ApplicationStatus.DRAFT]: 'Draft',
  [ApplicationStatus.RETURNED]: 'Returned',
  [ApplicationStatus.UNDER_REVIEW]: 'Under review',
  [ApplicationStatus.RETURNED_EXPIRED]: 'Returned Expired',
  [ApplicationStatus.PAYMENT_EXPIRED]: 'Payment Expired',
  SCHEDULED: 'Scheduled',
  PAID: 'Paid',
  COMPLETED: 'Completed',
  PENDING: 'Pending',
  FAILED: 'Failed',
  NOT_INITIALIZED: 'Pending',
  UNCLAIMED: 'Unclaimed',
  EXPIRED: 'Expired',
};

// i18n translation keys for application status
export const ApplicationStatusTextKeys: Record<string, string> = {
  [ApplicationStatus.APPROVED]: 'statusTags.approved',
  [ApplicationStatus.REJECTED]: 'statusTags.declined',
  [ApplicationStatus.SUBMITTED]: 'statusTags.pendingReview',
  [ApplicationStatus.DRAFT]: 'statusTags.draft',
  [ApplicationStatus.RETURNED]: 'statusTags.returned',
  [ApplicationStatus.UNDER_REVIEW]: 'statusTags.underReview',
  [ApplicationStatus.RETURNED_EXPIRED]: 'statusTags.returnedExpired',
  [ApplicationStatus.PAYMENT_EXPIRED]: 'statusTags.paymentExpired',
  SCHEDULED: 'statusTags.scheduled',
  PAID: 'statusTags.paid',
  COMPLETED: 'statusTags.completed',
  PENDING: 'statusTags.pending',
  FAILED: 'statusTags.failed',
  NOT_INITIALIZED: 'statusTags.pending',
  UNCLAIMED: 'statusTags.unclaimed',
  EXPIRED: 'statusTags.expired',
};

export const REQUEST_STATUS_COLOR = {
  SUBMITTED: 'blue',
  APPROVED: 'green',
  REJECTED: 'red',
  UNDER_REVIEW: 'spark',
  RETURNED: 'spark',
  DRAFT: 'gray',
  SCHEDULED: 'green',
  PAID: 'green',
  EXPIRED: 'red',
  RETURNED_EXPIRED: 'red',
  PAYMENT_EXPIRED: 'red',
};

// i18n translation keys for payment status
export const PaymentStatusKeys: Record<string, string> = {
  NOT_INITIALIZED: 'paymentStatus.notInitialized',
  PAID: 'paymentStatus.paid',
  REJECTED: 'paymentStatus.rejected',
  REFUND: 'paymentStatus.refund',
  SCHEDULED: 'paymentStatus.scheduled',
  UNCLAIMED: 'paymentStatus.unclaimed',
  PENDING: 'paymentStatus.pending',
  COMPLETED: 'paymentStatus.paid',
  FAILED: 'paymentStatus.failed',
  EXPIRED: 'paymentStatus.expired',
};

// i18n translation keys for Even app payment sub types
export const EvenAppPaymentSubTypeKeys: Record<string, string> = {
  ACH: 'paymentSubType.directDeposit',
  ONE_TRANSFER: 'paymentSubType.oneTransfer',
  D2C: 'paymentSubType.cash',
  UNCLAIMED: 'paymentSubType.unclaimed',
  CLAIMED: 'paymentSubType.claimed',
};

export const PaymentStatusDescription = {
  NOT_INITIALIZED: 'Payment being processed – may take 24 hours',
  PENDING: 'Payment being processed – may take 24 hours',
  PAID: 'Payment has been picked up / deposited',
  FAILED: 'Payment cannot be completed',
  PAYMENT_EXPIRED: 'Award has expired – after 90 days of not being completed',
  UNCLAIMED: 'Associate has not selected payment type',
};

export const POSITIVE_NUMBER_REGEX = /^\d*\.?\d*$/;

export const CURRENCY_REGEX_WITH_TWO_OR_MORE_DECIMAL_PLACES = /^\d+(\.\d{2,})$/;

export const NUMBER_AND_COMMA_REGEX = /[^0-9,]+$/;
export const LETTERS_AND_COMMA_REGEX = /[^a-zA-Z,]/g;

export const PHONE_NUMBER_REGEX = /^(\d{3})(\d{3})(\d{3,4})$/;

export const MAX_FILE_STR_LEN = 35;

export const ACNT_ASSOCIATE_ROLE = 'ACNT_ASSOCIATE';
export const ACNT_REVIEWER_ROLE = 'ACNT_REVIEWER';
export const ACNT_ADMIN_ROLE = 'ACNT_ADMIN';
export const ACNT_FINANCE_ROLE = 'ACNT_FINANCE';
export const ACNT_SUPPORT_TIER_1 = 'ACNT_SUPPORT_TIER_1';
export const ACNT_SUPPORT_TIER_2 = 'ACNT_SUPPORT_TIER_2';
export const ACNT_CHAT_ROLE = 'ACNT_CHAT_USER';
export const ACNT_REVIEWER_AUTOMATION = 'ACNT_REVIEWER_AUTOMATION';

export const MAX_INPUT_NUMBER_VALUE = 9999999999999.99;

export const MAX_FILE_SIZE_ADMIN = 26214400;

export const ASSOCIATE_HOME_PAGE = '/';
export const REVIEWER_HOME_PAGE = '/reviewer';
export const ADMIN_HOME_PAGE = '/admin';
export const FINANCE_HOME_PAGE = '/finance-report';

export const DISASTER_INPROGRESS = 'DA-F-2';
export const DISASTER_PRELIMCHECK = 'DA-F-1';

export enum GrantType {
  ALL = 'ALL',
  ASSOCIATE = 'ASSOCIATE',
  DISASTER = 'DISASTER',
}

export enum FeatureFlagType {
  ASSOCIATE = 'ASSOCIATE',
  DISASTER = 'DISASTER',
  ACXIOM = 'ACXIOM',
  EVEN_APP = 'EVEN_APP',
}

export const screenSizeHookVal = 768;

export const ALPHA_NUMBERIC_REGEX = /^[a-z0-9]+$/i;
export const POS_NUMBER_REGEX = /^[\d ]*$/;

export const MAX_FILE_UPLOAD_SIZE = 10485760;

export const PaymentType = {
  ACXIOM: { key: 'ACXIOM', value: 'CASH' },
  CHECK: { key: 'CHECK', value: 'CHECK' },
};

export enum FinanceReports {
  ACNTD2CReport = 'ACNTD2CReport',
  ACNTReconReport = 'ACNTReconReport',
  DetailedReport = 'DetailedReport',
  OutstandingReport = 'OutstandingReport',
}

export const SUPPORTED_FILE_TYPES = ['jpg', 'jpeg', 'png', 'doc', 'docx', 'pdf', 'heic'];

export enum EvenAppPaymentSubType {
  ACH = 'Direct Deposit',
  ONE_TRANSFER = 'One Transfer',
  D2C = 'Cash',
  UNCLAIMED = 'Unclaimed',
  CLAIMED = 'Claimed',
}

export const NO_COMMENTS_ADDED = 'No comments added';
